(function () {
  // redirect from /de to /de/ to avoid 404s as de is default language
  var url = new URL(window.location.href);
  var path = url.pathname;
  if (path !== '/de' && !path.startsWith('/de/')) return;
  url.pathname = path.slice('/de'.length) || '/';
  window.location.replace(url.href);
})();
